
<template>
  <!-- //ROUTER IF MOBILE -->
  <ion-content class="d-flex wrapper" v-if="isMobile">
      <div class="block block__resume">

          <transition
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 
  <!-- //ROUTER IF MOBILE -->

  <!-- //ROUTER IF DESKTOP -->
  <section class="d-flex wrapper" v-else>
      <SidebarMain class="desktop" />
      <div class="block block__resume">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </section> 
  <!-- //ROUTER IF DESKTOP -->
 
</template>

<script>
import SidebarMain from '../../module/sidebar/SidebarMain'
import CatMixin from './CatMixin'
import { mapGetters } from 'vuex'

export default {
  name:"resume",
  components:{
      SidebarMain,
  }, 
  mixins: [
    CatMixin
  ],        
  computed: {
    ...mapGetters([
      // 'getPageTransition',
    ])
  },
  created(){
    window.addEventListener('wheel', this.handleScroll);
  },
  activated() {
    window.addEventListener('wheel', this.handleScroll);
  },
  deactivated() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  methods:{
    handleScroll (event) {
      var container = this.$el.querySelector(".column-middle");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".column-right");
      if (container){
        container.scrollTop += event.deltaY;
      }
    }
  }

};
</script>
